import { action } from 'typesafe-actions';

import {
    ContextTypeKeys, PartyContextValues, QuestionContextValues,
} from './types';
import { RecordingContextValues } from '../../features/recordingHeader/types';
import type { AssessmentRunSession, WorkflowInfo } from './reducer';

export const assessmentRunIdUpdated = () => {
    return action(ContextTypeKeys.ASSESSMENT_RUN_ID_UPDATED);
};

export const workspaceIdUpdated = () => {
    return action(ContextTypeKeys.WORKSPACE_ID_UPDATED);
};

export const partyIdUpdated = () => {
    return action(ContextTypeKeys.PARTY_ID_UPDATED);
};

export const questionIdUpdated = () => {
    return action(ContextTypeKeys.QUESTION_ID_UPDATED);
};

export const committeeIdSelected = () => {
    return action(ContextTypeKeys.COMMITTEE_ID_SELECTED);
};

export const setupWorkspaces = () => {
    return action(ContextTypeKeys.SETUP_WORKSPACES);
};

export const setPartyState = (partyState: PartyContextValues) => {
    return action(ContextTypeKeys.SET_PARTY_STATE, partyState);
};

export const contextPropertiesUpdated = () => action(ContextTypeKeys.CONTEXT_PROPERTIES_UPDATED);

export const setQuestionState = (questionState: QuestionContextValues) => {
    return action(ContextTypeKeys.SET_QUESTION_STATE, questionState);
};

export const getGradingWorkflowInfo = () => {
    return action(ContextTypeKeys.GET_GRADING_WORKFLOW_INFO);
};

export const setGradingWorkflowInfo = (data: any) => {
    return action(ContextTypeKeys.SET_GRADING_WORKFLOW_INFO, data);
};

export const toggleDetailsPanel = () => action(ContextTypeKeys.TOGGLE_DETAILS_PANEL);

export const openExplanationRecordingPanel = (explanationContext: RecordingContextValues) => {
    return action(ContextTypeKeys.OPEN_RECORDING_PANEL, explanationContext);
};

export const openExplanationRecordingPanelDone = () => {
    return action(ContextTypeKeys.OPEN_RECORDING_PANEL_DONE);
};

export const updateQuestionsForPartyWithNewRevisionIds = (questions: any) => {
    return action(ContextTypeKeys.UPDATE_CONTEXT_PARTY_QUESTION_REVISION_IDS, questions);
};

export const loadAssessmentRunSession = (assessmentRunSessionId?: number) => {
    return action(ContextTypeKeys.LOAD_ASSESSMENT_RUN_SESSION, assessmentRunSessionId);
};

export const assessmentRunSessionLoaded = (assessmentRunSession: AssessmentRunSession) => {
    return action(ContextTypeKeys.ASSESSMENT_RUN_SESSION_LOADED, assessmentRunSession);
};

export const speakingQuestionSetIdsLoaded = (speakingQuestionSetIds: any) => {
    return action(ContextTypeKeys.SPEAKING_QUESTION_SET_IDS_LOADED, speakingQuestionSetIds);
};

export const setSpeakingSelectedContentItemId = (selectedContentItemId: number) => {
    return action(ContextTypeKeys.SET_SPEAKING_SELECTED_CONTENT_ITEM_ID, selectedContentItemId);
};

export const updateWorkflowInfo = (workflowInfoUpdate: Partial<WorkflowInfo>) => {
    return action(ContextTypeKeys.UPDATE_WORKFLOW_INFO, workflowInfoUpdate);
};

export const refreshHeartbeat = () => {
    return action(ContextTypeKeys.SPEAKING_REFRESH_HEARTBEAT);
};

export const submissionDeleted = (partyId: number) => {
    return action(ContextTypeKeys.SUBMISSION_DELETED, partyId);
};

export const updateQuestionState = () => {
    return action(ContextTypeKeys.UPDATE_QUESTION_STATE);
};

export const updateWorkspaceShowDetailView = () => {
    return action(ContextTypeKeys.TOGGLE_WORKSPACE_DETAILED_VIEW);
};
